import { Button, Icon, Loader, Modal } from '@afterpaytouch/core'
import React, { FunctionComponent, useEffect } from 'react'
import { useAppDispatch, useCheckoutToken, useIsApplePaylater, useLazyGetCheckoutPpaDocumentQuery } from '../../state'
import styles from './style.module.css'
import { TruthInLendingIframe } from './TruthInLendingIframe'
import { PayMonthlyTILAModalKey } from '../../model/modalKey'

interface TruthInLendingModalProps {
  show: boolean
  hideModal: () => void
  documentId: string
  isTilDisclosure: boolean
}

export const TruthInLendingModal: FunctionComponent<TruthInLendingModalProps> = ({ show, hideModal, documentId, isTilDisclosure }) => {
  const [getDocument, { data: documentData, isFetching: lazyDocumentIsLoading }] = useLazyGetCheckoutPpaDocumentQuery()
  const dispatch = useAppDispatch()
  const token = useCheckoutToken()
  const isApplePaylater = useIsApplePaylater()

  useEffect(() => {
    if (show) {
      dispatch(async () => await getDocument({ token, docId: documentId }))
    }
  }, [show, documentId])

  const printDocument = (): void => {
    const documentIframe: HTMLIFrameElement | null = document.querySelector('#document-window')
    if (documentIframe === null || documentIframe.contentWindow === null) {
      return
    }
    documentIframe.contentWindow.print()
  }

  return (
    <Modal id={PayMonthlyTILAModalKey} show={show} onBackdropClick={hideModal} showCloseButton={show} testNameSpace='til-document-modal'>
      <div className={styles.iframeModalBtn}>
        {!isApplePaylater && (
          <Button.Link type='button' aria-label='til-print-document-button' onClick={printDocument} disabled={lazyDocumentIsLoading}>
            <Icon.Printer size='Medium' color='Black' />
          </Button.Link>
        )}
        <Button.Link type='button' aria-label='til-close-modal-button' onClick={hideModal}>
          <Icon.Close size='Medium' color='Black' />
        </Button.Link>
      </div>
      {lazyDocumentIsLoading ? <Loader /> : <TruthInLendingIframe documentData={documentData} isTilDisclosure={isTilDisclosure} />}
    </Modal>
  )
}
